// extracted by mini-css-extract-plugin
export default {"wrapper":"Jz-z","viewport":"Kz-z","container":"Lz-z","slide":"Mz-z"};